import { Injectable } from '@angular/core';
import { PolicyRepoService } from '@client/app/services/api/policy-repo/policy-repo.service';
import { PolicyModel } from '@client/app/services/api/policy-repo/policy-model';
import { PolicyRepoType } from '@client/app/services/api/policy-repo/policy.types';

@Injectable({
    providedIn: 'root',
})
export class PolicyService {

    constructor (
        private policyRepoService: PolicyRepoService,
    ) { }

    create (params: Partial<PolicyRepoType>, config?: any): Promise<PolicyModel> {
        if (!params.targets) {
            params.targets = [];
        }
        return this.policyRepoService.create(params);
    }

    update (data: PolicyRepoType, params?: any, config?: any): Promise<PolicyModel> {
        return this.policyRepoService.update(data);
    }

    destroy (id: number, config?: any): Promise<void> {
        return this.policyRepoService.destroy(id);
    }

    run (id: number, params?: any, config?: any): Promise<void> {
        return this.policyRepoService.run(id);
    }
}
